import SwitcherRow from './SwitcherRow';
import SwitcherRowReduced from './SwitcherRowReduced';

export { SwitcherRowReduced };
export default SwitcherRow;
